import { render, staticRenderFns } from "./WidgetsStat.vue?vue&type=template&id=625733fe"
import script from "./WidgetsStat.vue?vue&type=script&lang=js"
export * from "./WidgetsStat.vue?vue&type=script&lang=js"
import style0 from "./WidgetsStat.vue?vue&type=style&index=0&id=625733fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports